import PanelLayout from "./panel-layout.container";

export default PanelLayout;
